import ResetPinModal from './ResetPinModal';

export default ResetPinModal;
